module.exports = __webpack_public_path__ + "img/first-rank-bg.bd2541ee.png";